// extracted by mini-css-extract-plugin
export default {"outer":"CheckboxContainer__outer____kvYI","checkbox":"CheckboxContainer__checkbox____TMCA","children":"CheckboxContainer__children___OzhyD"};